import axios from 'axios';

import type {
  FormResponse,
  IdentityCheckResponse,
  Pass,
  SanitisedPass,
  SignInInvitationRequest,
  SignInVisitorRequest,
  SigninRequirements,
  SignoutRequirements,
  VisitorIdentityCheckProps,
} from '@sine/sine-core-api-types';

import { preserveNull } from '../../helpers/nullPreserver';
import rxEventHub, { RxEvent } from '../events/rx';

export const VISIT_EVENT_TYPE = {
  SIGN_IN: 'signin',
  SIGN_OUT: 'signout',
};

const visitService = {
  async requirements(siteId: string, event = 'sinein') {
    const { data } = await axios.get<SigninRequirements | SignoutRequirements>(
      `${window.env.REACT_APP_SINE_CORE_API_URI}/visit/${event}/requirements/${siteId}`,
    );

    return data;
  },

  async identityCheck(siteId: string, props: VisitorIdentityCheckProps) {
    try {
      const { data } = await axios.post<IdentityCheckResponse>(
        `${window.env.REACT_APP_SINE_CORE_API_URI}/visit/sinein/identity-check/${siteId}`,
        props,
      );

      return data;
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  },

  async signIn(props: SignInVisitorRequest) {
    try {
      let { data: pass } = await axios.post<SanitisedPass<Pass>>(
        `${window.env.REACT_APP_SINE_CORE_API_URI}/visit/sinein`,
        props,
      );

      pass = preserveNull(pass);

      rxEventHub.broadcast(RxEvent.PASS_UPDATED, { pass });

      return pass;
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  },

  async signOut(props: { passId: string; formResponses?: FormResponse }) {
    try {
      let { data: pass } = await axios.post<SanitisedPass<Pass>>(
        `${window.env.REACT_APP_SINE_CORE_API_URI}/visit/sineout/pass`,
        props,
      );

      pass = preserveNull(pass);

      rxEventHub.broadcast(RxEvent.PASS_UPDATED, { pass });

      return pass;
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  },

  async signInInvitation(invitationId: string, params: SignInInvitationRequest) {
    try {
      let { data: pass } = await axios.post<SanitisedPass<Pass>>(
        `${window.env.REACT_APP_SINE_CORE_API_URI}/visit/sinein/invitation/${invitationId}`,
        params,
      );

      pass = preserveNull(pass);

      rxEventHub.broadcast(RxEvent.PASS_UPDATED, { pass });

      return pass;
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  },
};

export default visitService;
